import type { BankFlowComponent } from "./bankFlow.types.ts";
import { CsasFlow } from "./CsasFlow.tsx";
import { CsobFlow } from "./CsobFlow.tsx";
import { FioFlow } from "./FioFlow.tsx";
import { GenericBankFlow } from "./GenericBankFlow.tsx";
import { KbFlow } from "./KbFlow.tsx";
import { MonetaFlow } from "./MonetaFlow.tsx";
import { RaiffeisenFlow } from "./RaiffeisenFlow.tsx";
import { UnicreditFlow } from "./UnicreditFlow.tsx";

export type { BankFlowComponent, BankFlowProps, BankFlowStep } from "./bankFlow.types.ts";
export { GenericBankFlow } from "./GenericBankFlow.tsx";

// Faithful per-bank replicas of the real PSD2 screens (Confluence: "Screen
// flow when connecting to a bank"). Banks without a replica fall back to the
// generic account picker. Keys are paymentProvider enum values.
const BANK_FLOWS: Record<string, BankFlowComponent> = {
  FIO: FioFlow,
  CSOB: CsobFlow,
  CSAS: CsasFlow,
  MONETA: MonetaFlow,
  KB: KbFlow,
  RAIFFEISEN: RaiffeisenFlow,
  UNICREDIT: UnicreditFlow,
};

export function getBankFlow(provider: string): BankFlowComponent {
  return BANK_FLOWS[provider] ?? GenericBankFlow;
}
